<template>
  <WidgetBase
    :title="title"
    :title-link="titleLink"
    borderless
  >
    <slot />
  </WidgetBase>
</template>

<script setup>
import 'vue-data-ui/style.css'; // Include the css

import WidgetBase from './base.vue';

const props = defineProps({
  title: String,
  titleLink: String,
});
</script>

<style scoped>
.widget-card {
  margin: 10px;
}
</style>
